import { Button } from '@components/Button/';
import DevelopmentCard from '@components/Card/DevelopmentCard';
import Block from '@components/Layout/Block';
import { VerticalLineSeparator } from '@components/MiscComponents/VerticalLineSeparator';
import { contentAspectRatios } from '@components/NeighborhoodCardGrid';
import { FC } from 'react';
import { ButtonPadding, ContentWrapper, Headline } from './styles';
import { useTranslations } from 'next-intl';
import { getCorrectHeader, getCurrentLocale } from '@util/locale';

export type FeaturedContentType = {
  fields: {
    featuredImg: string;
    name: string;
    slug: string;
    isExternal?: string;
  };
};

export interface FeaturedContentProps {
  contentHeader: string;
  featuredContent?: any[];
  viewAllContentSlug: string;
  showViewAllContentButton: boolean;
  viewAllContentButtonText: string;
}

const FeaturedContent: FC<FeaturedContentProps> = ({
  contentHeader,
  featuredContent,
  viewAllContentSlug,
  showViewAllContentButton,
  viewAllContentButtonText,
}) => {
  const t = useTranslations();

  return (
    <Block>
      <Headline>{contentHeader ?? t('Featured Content')}</Headline>
      <VerticalLineSeparator />
      {featuredContent && featuredContent.length > 0 && (
        <ContentWrapper $amount={featuredContent.length}>
          {featuredContent.map((content: any, i: number) => {
            return (
              <div key={content.sys?.id}>
                <DevelopmentCard
                  img={content.fields?.featuredImg}
                  title={content.fields?.name}
                  url={content.fields?.slug}
                  isExternal={content.fields?.isExternal}
                  imageAspectRatio={contentAspectRatios[featuredContent.length][i]}
                />
              </div>
            );
          })}
        </ContentWrapper>
      )}
      {featuredContent && featuredContent.length > 2 && showViewAllContentButton && (
        <ButtonPadding>
          <Button
            variant="secondary"
            label={viewAllContentButtonText ?? t('View all content')}
            url={viewAllContentSlug ?? '/'}
            arrow={false}
          />
        </ButtonPadding>
      )}
    </Block>
  );
};

export default FeaturedContent;
